<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('general.contact')"
            />

            <div class="row">
                <div class="col-sm-12">
                    Gummies donut cookie donut apple pie. Tootsie roll ice cream pudding icing powder icing gingerbread liquorice sweet roll. Chocolate apple pie marzipan. Pie tootsie roll caramels jelly-o gummi bears caramels. Jelly-o marzipan tiramisu carrot cake muffin tiramisu jelly-o sweet roll. Tootsie roll marshmallow tiramisu bonbon sesame snaps carrot cake bonbon.
                </div>

            </div>


        </div>
    </main>
</template>
<script>

import PageHeader from '@/components/PageHeader/PageHeader';

export default {
    name: 'Contact',

    components: {
        PageHeader,
    },

    data() {
        return {

        };
    },

    methods: {

    },
};
</script>
